import { translateMessage } from 'common/components/Intl';

const translatedPurchaseLocations = (intl, locations) => {
  return locations.map(location => {
    return {
      value: location.key,
      label: translateMessage(
        intl,
        `common.purchase_location.locations.${location.key}`
      ),
    };
  });
};

export { translatedPurchaseLocations };
